const features = [
  {
    icon: '🚀',
    title: 'High-Speed Internet',
    desc: 'Experience blazing-fast speeds up to 10 Gbps with our fiber-optic network. Stream, game, and work without interruption.',
  },
  {
    icon: '💬',
    title: '24/7 Support',
    desc: 'Our expert team is always available to help you. Get instant support through chat, phone, or email anytime, anywhere.',
  },
  {
    icon: '🌐',
    title: 'Fiber Plans',
    desc: 'Next-generation fiber-optic technology delivers unmatched reliability and speed for your home or business.',
  },
  {
    icon: '📡',
    title: 'Wireless Packages',
    desc: 'Flexible wireless solutions for areas where fiber isn\'t available. Enjoy reliable connectivity without the cables.',
  },
];

export default features;
